import { useMemo } from 'react';

import { useIsPrivateContentModeEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const usePrivateContentModeSettings: UseMainUIFeatureSettings<'privateContentMode'> = (options) => {
  const privateContentModeOverrides = options?.overrides?.privateContentMode;

  const privateContentMode = useIsPrivateContentModeEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: privateContentMode,
      ...privateContentModeOverrides,
    }),
    [privateContentModeOverrides, privateContentMode]
  );
};
